import { render } from "./Sticky_dates.vue?vue&type=template&id=4b6df5ce"
import script from "./Sticky_dates.vue?vue&type=script&lang=js"
export * from "./Sticky_dates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__